


// Generated from io.spcfy.orders.samplemeta.enums.Sequencer

export type SequencerKey =
  "ISEQ_100" |
  "MINISEQ" |
  "MISEQ" |
  "MISEQ_I100" |
  "NEXTSEQ_550" |
  "NEXTSEQ_1000" |
  "NEXTSEQ_2000" |
  "NOVASEQ_6000" |
  "NOVASEQ_X_SERIES" |
  "HISEQ_2500" |
  "HISEQ_3000" |
  "HISEQ_4000";


export interface SequencerDTO {
  key: SequencerKey;
  label: string;    
}


export const Sequencers: Record<SequencerKey, SequencerDTO> = {
  ISEQ_100: { key: "ISEQ_100", label: "iSeq 100" },
  MINISEQ: { key: "MINISEQ", label: "MiniSeq" },
  MISEQ: { key: "MISEQ", label: "MiSeq" },
  MISEQ_I100: { key: "MISEQ_I100", label: "MiSeq i100" },
  NEXTSEQ_550: { key: "NEXTSEQ_550", label: "NextSeq 550" },
  NEXTSEQ_1000: { key: "NEXTSEQ_1000", label: "NextSeq 1000" },
  NEXTSEQ_2000: { key: "NEXTSEQ_2000", label: "NextSeq 2000" },
  NOVASEQ_6000: { key: "NOVASEQ_6000", label: "NovaSeq 6000" },
  NOVASEQ_X_SERIES: { key: "NOVASEQ_X_SERIES", label: "NovaSeq X Series (X Plus, X Standard)" },
  HISEQ_2500: { key: "HISEQ_2500", label: "HiSeq 2500" },
  HISEQ_3000: { key: "HISEQ_3000", label: "HiSeq 3000" },
  HISEQ_4000: { key: "HISEQ_4000", label: "HiSeq 4000" }
};
